module.exports = "a:link, a:visited {\n  background-color: #fd7e14;\n  color: white;\n  padding: 14px 25px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  min-width : 330px;\n  margin-bottom: 5px;\n  margin-top: 5px;\n}\n\na:hover, a:active {\n  background-color: #f77103;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/autolog/autolog.component.css
// module id = ./src/app/autolog/autolog.component.css
// module chunks = main